<template>
  <el-dialog
    title="详情"
    :visible.sync="show"
    width="960px"
    append-to-body
    :close-on-click-modal="false"
    custom-class="reserve-record-detail-dialog"
  >
    <div v-loading="isLoading" class="detail-body">
      <div class="detail-section">
        <div class="detail-section-header">
          <span>商品信息</span>
          <el-button type="text" class="communicate-link" @click="openCommunicateDialog">沟通记录</el-button>
        </div>
        <div class="detail-section-content product-info-content" v-if="reservation">
          <div class="product-preview">
            <div class="product-image">
              <el-image
                v-if="reservation.productMainImage"
                class="image"
                :src="reservation.productMainImage"
                fit="cover"
              />
              <img v-else src="../../../../../assets/images/default.png" class="image" />
            </div>
            <div class="product-title">{{ reservation.productName || '--' }}</div>
          </div>
          <div class="product-info-list">
            <div class="info-row">
              <span class="label">下单路径</span>
              <span class="value">{{ reservation.salesPathName || '--' }}</span>
            </div>
            <div class="info-row">
              <span class="label">预约数量</span>
              <span class="value">{{ formatDetailReservationQtyText(reservation) }}</span>
            </div>
            <div class="info-row">
              <span class="label">期望佣金</span>
              <span class="value">{{ formatListCommissionText(reservation) }}</span>
            </div>
            <div class="info-row">
              <span class="label">期望下单时间</span>
              <span class="value">{{ reservation.expectedOrderTime || '--' }}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="detail-section">
        <div class="detail-section-header">
          <span>约量反馈</span>
        </div>
        <div class="detail-section-content feedback-content">
          <el-table border stripe :data="feedbackList">
            <el-table-column type="index" label="序号" width="60" />
            <el-table-column prop="salesPathName" label="下单路径" min-width="100" show-overflow-tooltip />
            <el-table-column prop="sourceOrgName" label="来源机构" min-width="100" show-overflow-tooltip />
            <el-table-column label="可下单量" min-width="100">
              <template slot-scope="{ row }">
                {{ formatFeedbackOrderableText(row) }}
              </template>
            </el-table-column>
            <el-table-column label="佣金" min-width="140">
              <template slot-scope="{ row }">
                {{ formatFeedbackCommissionText(row) }}
              </template>
            </el-table-column>
            <el-table-column prop="orderableTime" label="可下单时间" min-width="160" />
            <el-table-column prop="precautions" label="下单注意事项" min-width="180" show-overflow-tooltip />
            <el-table-column prop="feedbackTime" label="反馈时间" min-width="160" />
          </el-table>
        </div>
      </div>
    </div>

    <div slot="footer" class="dialog-footer">
      <el-button @click="show = false">返回</el-button>
    </div>

    <ReserveRecordCommunicateDialog v-model="showCommunicateDialog" :record="record" />
  </el-dialog>
</template>

<script>
import ReserveRecordCommunicateDialog from '@/page/component/sections/xpk/sup/reserve-record-communicate-dialog'
import { getQdVolumeDetail } from '@/service/apis/supVolume'
import {
  formatListCommissionText,
  formatDetailReservationQtyText,
  formatFeedbackOrderableText,
  formatFeedbackCommissionText
} from '@/page/component/sections/xpk/sup/sup-volume-fields'

export default {
  name: 'ReserveRecordDetailDialog',
  components: {
    ReserveRecordCommunicateDialog
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    record: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      isLoading: false,
      reservation: null,
      feedbackList: [],
      showCommunicateDialog: false
    }
  },
  computed: {
    show: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  },
  watch: {
    value(val) {
      if (val) {
        this.loadDetail()
      }
    }
  },
  methods: {
    formatListCommissionText,
    formatDetailReservationQtyText,
    formatFeedbackOrderableText,
    formatFeedbackCommissionText,
    loadDetail() {
      if (!this.record || !this.record.id) {
        this.resetDetail()
        return
      }
      this.isLoading = true
      getQdVolumeDetail.call(this, { id: this.record.id }).then(res => {
        this.reservation = {
          ...(res.reservation || {}),
          productMainImage: (res.reservation && res.reservation.productMainImage)
            || this.record.productMainImage
            || ''
        }
        this.feedbackList = res.feedbackList || []
      }).finally(() => {
        this.isLoading = false
      })
    },
    resetDetail() {
      this.reservation = null
      this.feedbackList = []
    },
    openCommunicateDialog() {
      this.showCommunicateDialog = true
    }
  }
}
</script>

<style scoped>
.detail-body {
  min-height: 200px;
}

.detail-section {
  margin-bottom: 16px;
  border: 1px solid #eee;
  border-radius: 2px;
  overflow: hidden;
}

.detail-section:last-child {
  margin-bottom: 0;
}

.detail-section-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 40px;
  padding: 0 16px;
  background-color: #fafafa;
  border-bottom: 1px solid #eee;
  font-size: 14px;
  font-weight: 700;
  color: #333;
}

.communicate-link {
  padding: 0;
  font-size: 14px;
}

.detail-section-content {
  padding: 16px;
}

.product-info-content {
  display: flex;
  align-items: flex-start;
}

.product-preview {
  width: 120px;
  flex-shrink: 0;
  margin-right: 24px;
}

.product-image {
  position: relative;
  width: 100%;
  padding-top: 100%;
  background-color: #f5f5f5;
  border-radius: 2px;
  overflow: hidden;
}

.product-image .image {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.product-image .image ::v-deep .el-image__inner {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.product-title {
  margin-top: 8px;
  font-size: 12px;
  line-height: 18px;
  color: #333;
  text-align: center;
  word-break: break-all;
}

.product-info-list {
  flex: 1;
  padding-top: 8px;
}

.info-row {
  display: flex;
  line-height: 28px;
  font-size: 14px;
}

.info-row .label {
  flex-shrink: 0;
  width: 100px;
  color: #999;
}

.info-row .value {
  flex: 1;
  color: #333;
}

.feedback-content {
  padding: 0;
}

.feedback-content ::v-deep .el-table {
  border: none;
}

.dialog-footer {
  text-align: right;
}
</style>

<style>
.reserve-record-detail-dialog {
  margin-top: 5vh !important;
}

.reserve-record-detail-dialog .el-dialog__body {
  padding: 16px 20px;
  max-height: calc(90vh - 120px);
  overflow-y: auto;
}
</style>
